import React from 'react';
import PropTypes from 'prop-types';
import { minBy } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { buildSegmentRatingsPath, TypeRankingsFeaturesModel } from 'client/data/models/type-rankings-features';
import { TypeRankingsLink as RankingsLink } from 'site-modules/shared/components/type-rankings-link/type-rankings-link';

export function getSegmentRating(segmentRatings, submodelSlug) {
  if (!segmentRatings.some(({ slugRankedSubmodel }) => slugRankedSubmodel) || !submodelSlug) {
    return minBy(segmentRatings, 'rank');
  }

  return minBy(
    segmentRatings.filter(
      ({ slugRankedSubmodel, editorialSegment: { displayName } }) =>
        slugRankedSubmodel === submodelSlug || displayName.toLowerCase().includes(submodelSlug.toLowerCase())
    ),
    'rank'
  );
}

function TypeRankingsLinkUI({ segmentRatings = null, submodelSlug = null }) {
  if (!(segmentRatings && segmentRatings.length)) {
    return null;
  }
  const segmentRating = getSegmentRating(segmentRatings, submodelSlug);
  if (!segmentRating) {
    return null;
  }

  return (
    <RankingsLink
      key={segmentRating.editorialSegment.id}
      segmentRating={segmentRating}
      className="comparator-rankings-link badge bg-gray-lightest fw-normal btn text-gray-darker px-0_5 py-0_25 m-0_25"
      rankNumberClassName="fw-bold text-decoration-none"
      suppressDuplicate
      // Override <AspectRatioContainer> styles
      style={{
        fontSize: '0.75rem',
        top: '0',
        transform: 'none',
        width: 'auto',
        maxWidth: '100%',
        whiteSpace: 'normal',
      }}
    />
  );
}

TypeRankingsLinkUI.propTypes = {
  segmentRatings: PropTypes.arrayOf(TypeRankingsEntities.SegmentRating),
  submodelSlug: PropTypes.string,
};

const stateToPropsConfig = {
  segmentRatings: bindToPath(
    props => {
      const { makeSlug, modelSlug, year } = props;
      if (makeSlug && modelSlug && year) {
        return buildSegmentRatingsPath({ makeSlug, modelSlug, year });
      }
      return null;
    },
    TypeRankingsFeaturesModel,
    segmentRatings => segmentRatings.filter(({ rank }) => rank)
  ),
};

export const TypeRankingsLink = connectToModel(TypeRankingsLinkUI, stateToPropsConfig);
